//import { FaFacebook } from "react-icons/fa"

import { FaInstagram, FaFacebook } from "react-icons/fa"
import {
    FooterContainer,
    FooterWrap,
    SocialMediaWrap,
    SocialLogo,
    SocialIcon,
    SocialIconLink,
    SocialMedia
} from './FooterElement'

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialLogo to="/">Quán bún đậu 16</SocialLogo>
                        <SocialIcon>
                            <SocialIconLink href="/" target="_blank" aria-able="Facebook" rel="noopener noreferrer">
                                <FaFacebook />
                            </SocialIconLink>
                            <SocialIconLink href="/" target="_blank" aria-able="Instgram" rel="noopener noreferrer">
                                <FaInstagram />
                            </SocialIconLink>
                        </SocialIcon>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer
